import React, { FC } from 'react';
import { Grid, Typography } from '@mui/material';
import {
    CheckCircle as PublishedIcon,
    Edit as DraftIcon,
    Visibility as ReviewIcon,
    Block as UnpublishedIcon,
} from '@mui/icons-material';
import AccessTimeFilledIcon from '@mui/icons-material/AccessTimeFilled';
import styled from 'styled-components';
import { dividerColor, blueColor } from '../../../../@theme/vars';
import { Publication } from '@graphql/types';
import TitleLink from '../../styled/TitleLink';

const ItemWrapper = styled.div`
  padding: 15px 5px 10px;
  border-bottom: 1px solid ${dividerColor};
`;

const StyledDate = styled(Typography)`
  padding-top: 10px;
`;

const StatusIconWrapper = styled.span`
  margin-right: 8px;
  color: ${blueColor};
  vertical-align: middle;
`;

const TitleWrapper = styled.div`
  display: flex;
  align-items: center;
`;

type RelatedPublicationItemProps = {
    publication: Publication;
};

const getStatusIcon = (publishedAt: Date | null) => {
    if (!publishedAt || isNaN(publishedAt.getTime())) {
        return <AccessTimeFilledIcon fontSize="small" />;
    }

    const now = new Date();

    if (publishedAt <= now) {
        return <PublishedIcon fontSize="small" />;
    } else {
        return <AccessTimeFilledIcon fontSize="small" />;
    }
};

const RelatedPublicationItem: FC<RelatedPublicationItemProps> = ({ publication }) => {
    const publishedAt = publication.publishedAt ? new Date(publication.publishedAt) : null;

    return (
        <ItemWrapper>
            <Grid container alignItems="center" justifyContent="space-between">
                <Grid container item direction="column" xs={8}>
                    <TitleLink to={`/editor/${publication.uid}`}>
                        <TitleWrapper>
                            <StatusIconWrapper>
                                {getStatusIcon(publishedAt)}
                            </StatusIconWrapper>
                            <Typography variant="h2">
                                {publication.title || 'Без названия'}
                            </Typography>
                        </TitleWrapper>
                    </TitleLink>
                    {publishedAt && !isNaN(publishedAt.getTime()) && (
                        <StyledDate variant="subtitle1">
                            {publishedAt.toLocaleDateString('ru-RU', {
                                day: '2-digit',
                                month: '2-digit',
                                year: 'numeric',
                                hour: '2-digit',
                                minute: '2-digit',
                                hour12: false,
                            }).replace(',', '')}
                        </StyledDate>
                    )}
                </Grid>
            </Grid>
        </ItemWrapper>
    );
};

export default RelatedPublicationItem;